import AudiPlayer from "components/audio-player/audio-player";

export default AudiPlayer;
